function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTextPostPreviewImageTall = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 53",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a183b"
    },
    d: "M-.028 0h40v53h-40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.153 29.435 2.622 3.476h-3.499l-.872-1.156-1.419 1.881 1.066 1.415h9.174l-5.656-7.5-1.416 1.884Zm-7.214-4.923-2.496-3.309h-2.835l5.331 7.07 6.948-9.212h3.501l-10.449 13.85L9.492 19.067l9.836-.006 1.491 1.976 1.418-1.882-1.685-2.238-15.516.003 14.903 19.752 14.91-19.755h-9.185l-5.725 7.595Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTextPostPreviewImageTall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/TextPostPreviewImageTall.2b7c67a26035a7a7811a5df3e77b98be.svg";